import { useEffect } from "react";

import { ApiService } from "../../../service/ApiService";

import { useBlogSelectors } from "../../../store/blog/blog.selectors";
import { BlogAction } from "../../../store/blog/blog.slice";
import { useMainPageState } from "../../../store/main-page/main-page.selectors";
import { getContent } from "../../../store/main-page/main-page.thunks";

import { collectServerSideState } from "../../../utils/helpers/collectServerSideState";

import { useQueryData } from "../../../hooks";
import { useDispatchedActions } from "../../../hooks/use-dispatch-actions";

import { Seo } from "../../../components/Seo/Seo";
import { Faq } from "../../../components/common/Faq/Faq";
import { FactsModule } from "./components/FactsModule/FactsModule";
import { HeroModule } from "./components/HeroModule/HeroModule";
import { QualitiesModule } from "./components/QualitiesModule/QualitiesModule";

const HomePage = () => {
  const { isDataLoaded } = useMainPageState();
  const { getContent, getBlogFacts } = useDispatchedActions();
  const { languageCode } = useQueryData();

  const { blogLanguage } = useBlogSelectors();

  useEffect(() => {
    if (!isDataLoaded) {
      getContent();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDataLoaded]);

  useEffect(() => {
    if (!blogLanguage || blogLanguage !== languageCode) {
      getBlogFacts(languageCode);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [languageCode, blogLanguage]);

  return (
    <>
      <HeroModule />
      <QualitiesModule />
      <Faq />
      <FactsModule />
      <Seo />
    </>
  );
};

HomePage.getServerSideState = async (store, params) => {
  await collectServerSideState(store, params);
  const state = store.getState();

  if (!state.mainPage.mainPageData) {
    await store.dispatch(getContent());
  }

  const locale = params.locale;

  try {
    const factsData = await ApiService.getBlogFacts(locale);

    if (factsData) {
      store.dispatch(
        BlogAction.saveServerBlogFacts({
          data: factsData.data,
          languageCode: locale,
        }),
      );
    }
  } catch (e) {
    console.log("Blog: Error in fetch blog facts, ", e.message);
  }
};

export default HomePage;
